<template>
  <renderjson v-bind:data="rendered_obj" />
</template>

<script>
// See note about VueJsonPretty in src/components/RenderLedger
import renderjson from '../vendor/renderjson/renderjson.vue'
import util       from '../util'

export default {
  name: 'RenderedLedgerObj',

  props : {
    obj : Object
  },

  components : {
    renderjson
  },

  computed : {
    rendered_obj : function(){
      var obj = JSON.parse(JSON.stringify(this.obj));
      return util.transform_ledger_json(obj);
    }
  }
}
</script>

<style scoped>
</style>
